<template>
  <section>
    <div class="row justify-content-between pa-3">
      <div>{{ is_trans ? $t(title) : title }}</div>
      <div class="d-flex align-center">
        <div :class="textColor">{{ value }}</div>
        <v-btn
          icon
          dense
          v-if="button"
          @click="$emit('showDetailedCalculation')"
        >
          <v-icon small>fal fa-info-circle</v-icon>
        </v-btn>
      </div>
    </div>
    <v-divider v-if="divider" />
  </section>
</template>

<script>
export default {
  emits: ["showDetailedCalculation"],
  props: {
    title: {
      type: String,
      required: true,
    },
    is_trans: {
      type: Boolean,
      default: true,
    },
    value: {
      default: "",
    },
    divider: {
      type: Boolean,
      default: true,
    },
    textColor: {
      type: String,
      default: "",
    },
    button: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
